import {DataTable, Text} from '@/components-v2'
import {PromotionListHeader} from './PromotionListHeader'
import {usePromotionListColumnsV2} from '@/hooks/usePromotionListColumnsV2'
import {usePromotionListTableV2} from '@/hooks/usePromotionListTableV2'

const PromotionList = () => {
  const {
    columns,
    tableData,
    pageIndex,
    pageSize,
    totalRowsCount,
    manualPagination,
    manualSorting,
    manualFiltering,
    onPageIndexChange,
    onRowsPerPageChange,
    sortingHandler,
    onColumnFiltersChange,
    resetFilterButtonOptions,
    onTableReady,
    rowSelectionStateUpdater,
    canDownload,
    isDownloading,
    onDownloadClick,
    resetKey,
    handleCopyClick,
    formData,
    setFormData,
    downloadPromoTemplate,
  } = usePromotionListTableV2()

  const transformedColumns = usePromotionListColumnsV2(columns, handleCopyClick)

  const customHeader = (
    <PromotionListHeader
      resetFilterButtonOptions={resetFilterButtonOptions}
      canDownload={canDownload}
      isDownloading={isDownloading}
      onDownloadClick={onDownloadClick}
      formData={formData}
      setFormData={setFormData}
      downloadPromoTemplate={downloadPromoTemplate}
    />
  )

  return (
    <div className="flex flex-col gap-4 rounded-lg bg-[var(--color-background-layer-01)] p-6">
      <Text headingLevel={5}>Promotions list</Text>
      <DataTable
        key={resetKey}
        columns={transformedColumns}
        data={tableData}
        pageIndex={pageIndex}
        pageSize={pageSize}
        totalRowsCount={totalRowsCount}
        onPageIndexChange={onPageIndexChange}
        onRowsPerPageChange={onRowsPerPageChange}
        manualPagination={manualPagination}
        manualSorting={manualSorting}
        manualFiltering={manualFiltering}
        sortingHandler={sortingHandler}
        onColumnFiltersChange={onColumnFiltersChange}
        resetFilterButtonOptions={resetFilterButtonOptions}
        selection="multiple"
        onTableReady={onTableReady}
        rowSelectionStateUpdater={rowSelectionStateUpdater}
        showTableHeader={false}
        customHeader={customHeader}
      />
    </div>
  )
}

export default PromotionList
